<template>
  <div class="inherit">
    <Search title="单基因病" :attent="num + '项携带'" :total="'共计评价' + total + '种疾病'" :child="child" backurl="/home">
      <div class="box">
        <van-tabs v-model="activeTab">
          <van-tab title="携带项目">
            <div v-if="gdb3">
              <div class="risk-cell" v-for="(item, index) in carry_list" :key="index" @click.stop="$router.push('/inheritInfo/' + item.id)">
                <p v-if="gdb3" class="title">{{item.name}}</p>
                <p v-else class="title">{{item.chname}}</p>
                <p>遗传模式：<span>{{ item.inherit_type }}</span></p>
              </div>
            </div>
            <div v-if="gdb2">
              <div class="risk-cell" v-for="(item, index) in carry_list" :key="index" @click.stop="$router.push('/inheritInfo/' + item.itemid)">
                <p v-if="gdb3" class="title">{{item.name}}</p>
                <p v-else class="title">{{item.chname}}</p>
                <p>遗传模式：<span>{{ item.inherit_type }}</span></p>
              </div>
            </div>
            <div class="noCarry" v-if="carry_list.length === 0 && !loading2">
              <img src="../../assets/images/nothing2.png" alt="未携带">
            </div>
          </van-tab>

          <van-tab title="全部项目">
            <ul v-if="gdb3">
              <li class="risk-cell no_click" :class="{no_click: item.id}" v-for="(item, index) in data" :key="index">
                <p class="title">{{item.name}}</p>
                <p>基因：{{ item.gene_name }} &nbsp;&nbsp; 遗传模式：{{item.inherit_type}}</p>
                <div v-if="item.id" class="right-icon" :class="item.id && 'high-level'">携带</div>
                <div v-else class="right-icon" >未携带</div>
              </li>
              <li class="seeMore">
                <span @click.stop="loadMore" v-if="has_next && !loading">查看更多</span>
              </li>
            </ul>
            <ul v-if="gdb2">
              <li class="risk-cell no_click" :class="{no_click: item.id}" v-for="(item, index) in data" :key="index">
                <p class="title">{{item.chname}}</p>
                <p>基因：{{ item.gene_name }} &nbsp;&nbsp; 遗传模式：{{item.inherit_type}}</p>
                <div class="right-icon">{{ item.conclusion }}</div>
              </li>
              <li class="seeMore">
                <span @click.stop="loadMore" v-if="has_next && !loading">查看更多</span>
              </li>
            </ul>
            <div style="width: 28px;margin: 20px auto;" v-if="loading">
              <van-loading color="#1989fa" />
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </Search>
  </div>
</template>

<script>
import Search from '@/components/Search'
export default {
  name: 'index',
  data () {
    return {
      gdb3: false,
      gdb2: false,
      child: this.util.getLS(this.api.child), // 是否是儿童版报告
      num: '',
      total: '',
      activeTab: 0,
      data: [],
      carry_list: [],
      page: 1,
      has_next: true,
      loading: false,
      loading2: true,
      totaldata: 0
    }
  },
  methods: {
    // 数量接口
    getQuantity () {
      this.util.get(this.api.inherit_quantity, '', (success) => {
        this.num = success.num
        this.total = success.total
      })
    },
    getInheritCarryInherits () {
      this.util.get(this.api.inherit_carry_inherits, '', (success) => {
        this.carry_list = success.items
        this.loading2 = false
        this.util.setLS('paginationData', success.items)
      })
    },
    getInheritItems () {
      this.util.get(this.api.inherit_items + '?page=' + this.page, '', (success) => {
        this.data = this.data.concat(success.items)
        this.loading = false
      }, 1000)
    },
    loadMore () {
      let that = this
      if (!this.has_next) {
        return false
      }
      this.loading = true
      this.page++
      if (that.totaldata < this.total) {
        if (this.gdb3) {
          this.getInheritItems()
        } else {
          this.getInheritItems1()
        }
      } else {
        console.log('不执行')
        that.has_next = false
      }
    },
    // gdb2
    getInherit () {
      this.util.get1(this.api.inherit, '', (success) => {
        this.carry_list = success.list
        this.num = success.carry_count
        this.total = success.inherit_count
        this.loading2 = false
      })
    },
    getInheritItems1 () {
      this.util.get1(this.api.inheritAppendix + '?page=' + this.page, '', (success) => {
        this.data = this.data.concat(success.diseases)
        this.loading = false
      }, 1000)
    }
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
      this.getQuantity()
      this.getInheritCarryInherits()
      this.getInheritItems()
    } else {
      this.gdb2 = true
      this.getInherit()
      this.getInheritItems1()
    }
  },
  components: {
    Search
  }
}
</script>

<style lang="scss">
  .inherit {
    height: 100%;
    background-color: #fff;
  }
</style>
<style scoped lang="scss">
  .risk-cell p {
    padding-right: .4rem;
    font-size: .115rem;
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// src/views/inherit/index.vue